/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Unread({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#Unread_svg__a)"><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="M7.86 2.5H2a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V7.516M15 12l-3.969-3.969M1 12l3.969-3.969" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} d="m1 3.5 4.742 5.42a3 3 0 0 0 4.516 0l.695-.81" /><circle cx={12.5} cy={3.5} r={3.5} fill="var(--primary-solid)" /></g><defs><clipPath id="Unread_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;